export default __webpack_public_path__ + "assets/images/b0efeef94becc055cec631f976b1da83.svg";